<template>
  <div>
    <v-btn small color="orange darken-3" dark @click="dialog = true" v-if="isAdd">
      <v-icon size="14" class="mr-1">mdi-text-box-plus</v-icon>
      Input Ekle
    </v-btn>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline title">
          <v-icon left color="black">mdi-plus</v-icon>
          <span class="mr-2" v-if="isAdd">Input Ekle</span>
          <span class="mr-2" v-else-if="isEdit">Input'u Güncelle</span>
          <v-spacer></v-spacer>
          <v-chip color="primary" dark small class="text-subtitle-2">Opsiyon: ( {{ activeOption.name }} ) </v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <v-col cols="12">
            <language-structured-data v-if="dialog" ref="languageStructuredData" v-model="inputLangData">
              <template v-slot="{ data }">
                <p class="text-subtitle-1 text-overline mb-0">
                  <v-icon size="21" color="primary">mdi-chevron-right</v-icon>
                  Input bilgileri
                </p>
                <v-text-field label="İnput 'için text girin (*)" prepend-icon="mdi-form-textbox" hide-details v-model="data.inputText"></v-text-field>
                <div class="mb-2"></div>
                <v-text-field label="İnput 'için placeholder girin (zorunlu değil)" prepend-icon="mdi-form-textbox" hide-details v-model="data.inputPlaceholder"></v-text-field>
              </template>
            </language-structured-data>
            <div class="mb-5"></div>
            <p class="text-subtitle-1 text-overline mb-0">
              <v-icon size="19" color="primary">mdi-chevron-right</v-icon>
              Input özellikleri
            </p>
            <v-row>
              <v-col cols="12" lg="6" class="py-0">
                <v-select prepend-icon="mdi-text-short" label="* Input ''type'' seçin" :items="inputTypes" v-model="inputData.type"></v-select>
              </v-col>
              <v-col cols="12" lg="6" class="py-0">
                <v-text-field label="* Input ''name''" prepend-icon="mdi-text-short" hide-details v-model="inputData.name"></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="py-0">
                <v-select prepend-icon="mdi-text-short" label="Input sınıfı" :items="inputClass" v-model="inputData.class" no-data-text="Lütfen input type seçin"></v-select>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-switch class="text-subtitle-1" label="Tüm dillerde aynı değeri göster" hint="Aktif olduğunda tüm ülke dillerinde aynı çıktıyı verir" persistent-hint v-model="inputData.merge"></v-switch>
              </v-col>
              <v-col cols="12" class="py-0">
                <p class="text-subtitle-1 text-overline my-4">
                  <v-icon size="19" color="primary">mdi-chevron-right</v-icon>
                  Input Ek Özellikleri
                  <sup class="text-capitalize">(Attributes)</sup>
                </p>
              </v-col>
              <v-col cols="12" lg="5" class="py-0">
                <v-text-field v-model="inputAttr.attr" label="Özellik" hint="(örn: color)" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" lg="5" class="py-0">
                <v-text-field v-model="inputAttr.value" label="Değer" hint="(örn: blue)" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" class="d-flex align-center justify-center py-0">
                <v-btn small color="green" dark class="text-capitalize" @click="addInputAttr()"> <v-icon size="15">mdi-plus</v-icon>&nbsp; Ekle </v-btn>
              </v-col>
              <v-col cols="12">
                <div class="py-2">
                  <v-chip :key="attr" v-for="(value, attr) in inputData.attrs" class="pr-1 mr-2" color="purple" dark>
                    {{ attr }}="{{ value }}"
                    <v-btn x-small icon color="purple" class="white ml-2 mr-1" @click="delInputAttr(attr)">
                      <v-icon size="15" color="purple">mdi-close</v-icon>
                    </v-btn>
                  </v-chip>
                </div>
                <div class="d-flex justify-center py-2">
                  <v-chip class="text-caption grey--text px-8" small label v-show="Object.keys(inputData.attrs).length === 0">Eklenmiş özellik yok </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeDialog()">
            <v-icon size="19" left>mdi-cancel</v-icon>
            İptal
          </v-btn>
          <v-btn v-if="isAdd" color="green darken-1" text @click="addInput()">
            <v-icon dense>mdi-plus</v-icon>
            Ekle
          </v-btn>
          <v-btn v-else-if="isEdit" color="green darken-1" text @click="updateInput()">
            <v-icon dense>mdi-plus</v-icon>
            Güncelle
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import OptionService from "@/services/OptionService";
import { prepare, prepareFromData } from "@/core/modules/LanguageStructuredData";
import LanguageStructuredData from "@/components/LanguageStructuredData.vue";

export default {
  name: "AddInput",
  components: { LanguageStructuredData },
  props: {
    type: {
      required: false,
      default: "add"
    },
    edit: {
      required: false,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    /**
     * Dile dahil olan input data
     */
    inputLangData: null,
    /**
     * Dile dahil olmayan input data
     */
    inputData: {
      type: "",
      name: "",
      value: "",
      option: "", // Geçerli opsiyon
      merge: true,
      class: "",
      attrs: {}
    },
    /**
     * Input düzenleme verisi
     */
    inputEditData: "",
    /**
     * Resetleme işlemi için
     */
    inputResetData: {},
    /**
     * Seçilebilen class'lar
     */
    inputClass: [],
    /**
     * Input'a özellik eklemek için data
     */
    inputAttr: {
      attr: "",
      value: ""
    }
  }),
  methods: {
    /**
     * Input CRUD işlemlerinden sonra listeyi güncelle
     */
    inputList() {
      let dispatch = this.optionStore() + "getInputList";

      const { optionName, optionType } = this.activeOptionType,
        optionSysName = this.activeOption.sysname,
        lang = this.apiLanguage;

      this.$store.dispatch(dispatch, {
        optionName,
        optionType,
        optionSysName,
        lang
      });
    },
    /**
     * Input eklemesi yapar
     *
     * @returns void
     */
    addInput() {
      const { optionName, optionType } = this.activeOptionType,
        activeOptionCode = this.activeOption.code,
        activeOptionName = this.activeOption.name;

      let inputData = {};

      for (let d in this.inputData) {
        inputData["input" + d[0].toUpperCase() + d.slice(1)] = this.inputData[d];
      }

      let inputLangData = this.$refs.languageStructuredData.languageStructuredData.getAsRequestPayload();

      /**
       * Input verilerini topla
       */
      const inputReq = Object.assign(inputData, { ...inputLangData }, { optionName, optionType }, { inputOption: activeOptionCode });

      /**
       * Input ekleme işlemi
       */
      OptionService.addInput(inputReq).then(res => {
        if (res.status === 200) {
          this.$snotify.success('Input "' + activeOptionName + '" adlı opsiyona başarıyla eklenmiştir', this.$t('PANEL.NOTIFY.SUCCESS'));
          this.inputList();
          this.closeDialog();
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    /**
     * Input güncellemesi yapar
     *
     * @returns void
     */
    updateInput() {
      const { optionName, optionType } = this.activeOptionType,
        activeOptionCode = this.activeOption.code,
        inputCode = this.edit[0].code;

      let inputData = {};

      for (let d in this.inputData) {
        inputData["input" + d[0].toUpperCase() + d.slice(1)] = this.inputData[d];
      }

      let inputLangData = this.$refs.languageStructuredData.languageStructuredData.getAsRequestPayload();

      /**
       * Input verilerini topla
       */
      const inputReq = Object.assign(inputData, { inputCode }, { ...inputLangData }, { optionName, optionType }, { inputOption: activeOptionCode });

      /**
       * Input ekleme işlemi
       */
      OptionService.updateInput(inputReq).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Input başarıyla güncellenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
          this.inputList();
          this.closeDialog();
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    /**
     * Input'a attr eklemesi yapar. Boş değerle
     * ekleme yapılmaya çalışırsa tepki vermez.
     *
     * @returns void
     */
    addInputAttr() {
      let { attr, value } = this.inputAttr;
      attr = attr.replaceAll(" ", "").toLowerCase();

      // Düzenlemede array olarak geliyor
      if (this.inputData.attrs.constructor === Array) {
        this.inputData.attrs = {};
      }

      if (attr && value) {
        this.inputData.attrs[attr] = value;
        this.inputAttr.attr = "";
        this.inputAttr.value = "";
      }
    },
    /**
     * Eklenmiş olan bir attr'ı kaldırır
     *
     * @param {string} del
     *
     * @returns void
     */
    delInputAttr(del) {
      let attrs = {};
      Object.keys(this.inputData.attrs).forEach(attr => {
        if (del != attr) attrs[attr] = this.inputData.attrs[attr];
      });
      this.inputData.attrs = attrs;
    },
    optionStore() {
      const { optionName, optionType } = this.activeOptionType;
      let opt = { optionName, optionType },
        optionStore = "";

      if (opt.optionType === this.$moduleTypes.apiType) {
        optionStore = "Option/ApiOptions/";
      } else if (opt.optionType === this.$moduleTypes.modulesType) {
        optionStore = "Option/ModuleOptions/";
      } else if (opt.optionType === this.$moduleTypes.pluginsType) {
        optionStore = "Option/PluginOptions/";
      }

      return optionStore;
    },
    /**
     * Dialog'u kapatır
     *
     * @returns void
     */
    closeDialog() {
      this.resetOptionData = true;
      this.inputData = JSON.parse(JSON.stringify(this.inputResetData));
      this.dialog = false;
    }
  },
  computed: {
    ...mapState({
      inputClasses: state => state.Option.inputClasses,
      activeOption: state => state.Option.option,
      activeOptionType: state => state.Option.optionType,
      apiLanguage: state => state.Language.apiLanguage
    }),
    ...mapGetters({
      convertProps: "Language/convertProps"
    }),
    inputTypes() {
      return Object.keys(this.inputClasses);
    },
    isAdd() {
      return this.type === "add";
    },
    isEdit() {
      return this.type === "edit";
    }
  },
  watch: {
    "inputData.type"(inputType) {
      this.inputClass = this.inputClasses[inputType];
    },
    edit(inputData) {
      if (this.isEdit) {
        this.inputLangData = prepareFromData(inputData, { text: "inputText", placeholder: "inputPlaceholder" });

        let localData = inputData[0];

        this.inputData.type = localData.type;
        this.inputData.name = localData.name;
        this.inputData.value = localData.value;
        this.inputData.option = localData.option;
        this.inputData.merge = !!localData.merge;
        this.inputData.class = localData.class;
        this.inputData.attrs = localData.attrs;

        this.dialog = true;
      }
    }
  },
  created() {
    if (!this.isEdit) {
      this.inputLangData = prepare(this.apiLanguage, {
        inputText: "",
        inputPlaceholder: ""
      });
    }

    this.inputResetData = JSON.parse(JSON.stringify(this.inputData));
  }
};
</script>

<style></style>
